const localizers = {
  'loading.msg': () => `正在加载...`,
  'SASServer.genericError.msg': () => `无法访问服务器。`,
  'SASReport.genericError.msg': () => `无法加载选定的报表。`,
  'SASReportImage.genericError.msg': () => `报表图像加载失败。`,
  'SASReportImage.imageNotSupported.msg': () => `该报表内容类型不支持图像。`,
}
export default localizers;
